import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { NavigationItem, NavigationKey } from 'modules/experience-core';

import { ALL_NAVIGATION_ITEMS } from '../constants';

export const useActiveNavigation = () => {
  const {
    location: { pathname },
  } = useHistory();

  const [activeNavigation, setActiveNavigation] = useState<NavigationItem | null>(null);

  useEffect(() => {
    const currentActiveNavigationItem = ALL_NAVIGATION_ITEMS.find(item => {
      // The item link is a valid path segment, even at the end of the url and with query params
      // Use case: not match /translations used in the shared menu with /translation
      const urlPattern = new RegExp(`${item.link}(\\/|\\?|$)`);
      const isUrlMatch = urlPattern.test(pathname);
      if (isUrlMatch && item.key === NavigationKey.CAMPAIGNS && pathname.includes('/merchant')) {
        return item.isVenueSpecific === false;
      }

      return isUrlMatch;
    });
    const isNavigationChanged = currentActiveNavigationItem?.key !== activeNavigation?.key;
    if (isNavigationChanged && currentActiveNavigationItem) {
      setActiveNavigation(currentActiveNavigationItem);
    } else if (isNavigationChanged) {
      setActiveNavigation(null);
    }
  }, [activeNavigation, pathname]);

  return {
    activeNavigation,
    setActiveNavigation,
  };
};
